import React, { useState } from "react";
import "../../styles/ExamResults.css";
import Navbar from '../Navbar/Navbar';
import Footer from '../Footer/Footer';
import { FaSearch, FaBook, FaArrowRight } from "react-icons/fa";

const ALL_RESULTS = [
  { title: "FY B.Sc Result", course: "B.Sc", year: "FY", link: "https://results.unipune.ac.in" },
  { title: "SY B.Sc Result", course: "B.Sc", year: "SY", link: "https://results.unipune.ac.in" },
  { title: "TY B.Sc Result", course: "B.Sc", year: "TY", link: "https://results.unipune.ac.in" },
  { title: "B.Sc Computer Science Result", course: "B.Sc CS", year: "TY", link: "https://results.unipune.ac.in" },
  { title: "B.A Results", course: "B.A", year: "ALL", link: "https://results.unipune.ac.in" },
  { title: "Revaluation Results", course: "Services", year: "ALL", link: "https://results.unipune.ac.in" },
  { title: "Photocopy Results", course: "Services", year: "ALL", link: "https://results.unipune.ac.in" },
  { title: "Backlog Results", course: "Services", year: "ALL", link: "https://results.unipune.ac.in" },
  { title: "Direct SPPU Result Portal", course: "SPPU", year: "ALL", link: "https://results.unipune.ac.in" },
];

export default function ResultsPage() {
  const [search, setSearch] = useState("");
  const [courseFilter, setCourseFilter] = useState("ALL");
  const [yearFilter, setYearFilter] = useState("ALL");
  const [loadingLink, setLoadingLink] = useState(null);

  const filteredResults = ALL_RESULTS.filter((r) => {
    return (
      (courseFilter === "ALL" || r.course === courseFilter) &&
      (yearFilter === "ALL" || r.year === yearFilter) &&
      r.title.toLowerCase().includes(search.toLowerCase())
    );
  });

  const handleCardClick = (link, idx) => {
    setLoadingLink(idx);

    setTimeout(() => {
      window.open(link, "_blank");
      setLoadingLink(null);
    }, 1200);
  };

  return (
    <>
    < Navbar />
    <div className="results-page fade-in-page">

      <h1 className="results-title">Examination Results</h1>

      {/* Search + Filters */}
      <div className="filters-container">
        <div className="search-box">
          <FaSearch className="search-icon" />
          <input
            type="text"
            placeholder="Search results..."
            value={search}
            onChange={(e) => setSearch(e.target.value)}
          />
        </div>

        <select
          className="filter-dropdown"
          value={courseFilter}
          onChange={(e) => setCourseFilter(e.target.value)}
        >
          <option value="ALL">All Courses</option>
          <option value="B.Sc">B.Sc</option>
          <option value="B.Sc CS">B.Sc Computer Science</option>
          <option value="B.A">B.A</option>
          <option value="Services">Result Services</option>
        </select>

        <select
          className="filter-dropdown"
          value={yearFilter}
          onChange={(e) => setYearFilter(e.target.value)}
        >
          <option value="ALL">All Years</option>
          <option value="FY">FY</option>
          <option value="SY">SY</option>
          <option value="TY">TY</option>
        </select>
      </div>

      {/* Results Grid */}
      <div className="results-grid">
        {filteredResults.map((r, i) => (
          <div
            key={i}
            className="result-card slide-up"
            onClick={() => handleCardClick(r.link, i)}
          >
            <FaBook className="result-icon" />
            <p>{r.title}</p>

            <FaArrowRight className="go-icon" />

            {loadingLink === i && (
              <div className="loader"></div>
            )}
          </div>
        ))}

        {filteredResults.length === 0 && (
          <p className="no-results">No matching results found.</p>
        )}
      </div>
    </div>
    < Footer />
    </>
  );
}
